// types
import { ToolConfigTypes, ToolNameTypes } from '../types/tools.types';
import { CalculatorCreatorConfigTypes } from '../types/calculatorCreator.types';

// constants
import { CALCULATOR_CREATOR_FORMULAS_PATH } from '../commonConstants/calculatorsConstants';
import toolsList from '../commonConstants/toolsList';

export default function getToolConfig(
  wrapper?: HTMLDivElement,
  toolName?: ToolNameTypes,
): ToolConfigTypes | {} {
  let toolConfig = {};
  if (wrapper?.dataset?.dpwsToolConfig) {
    toolConfig = JSON.parse(wrapper.dataset.dpwsToolConfig);
  }
  if (toolName === toolsList.calculatorCreator.name) {
    const { calculatorId } = toolConfig as CalculatorCreatorConfigTypes;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const calculatorCreatorFormulas = (window as any)[CALCULATOR_CREATOR_FORMULAS_PATH][
      calculatorId
    ];
    toolConfig = { ...toolConfig, ...calculatorCreatorFormulas };
  }

  return toolConfig;
}
